import { mount } from 'svelte';
import MySubmissionsListview from './templates/MySubmissionsListview.svelte';

export const initMySubmissions = () => {
  const eventList = document.querySelector('#js-submissions-list');

  if (!eventList) {
    return;
  }

  mount(MySubmissionsListview, {
    target: eventList,
  });
};
